import { mapActions } from 'vuex';

import Events from '_utils/events';
import ProductService from '_services/rest/modules/product';
import { _OPEN_MODAL_, _RELOAD_SAMPLE_AGENT_, MODAL_TYPE } from '_modules/sample/components/SampleModel';

export default {
  data() {
    return {
      agents: [],
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    async getListAgents(name = '', slug) {
      try {
        this.toggleLoading();
        const params = {
          skip: 0,
          take: 10,
          search: name,
          slug,
        };
        const response = await ProductService.getList(params);
        this.agents = response.list;
      } finally {
        this.toggleLoading();
      }
    },
    setAutocompleteValue(refName, value) {
      const autocomplete = this.$refs[refName];
      const input = autocomplete?.$refs?.input;
      if (input && value) {
        input.value = value;
      }
    },
    openModalEditAgent(agentId, typeSample = null, index = null) {
      this.setToggle({ type: MODAL_TYPE, bool: true });
      Events.$emit(_OPEN_MODAL_, {
        agentId, index, typeSample, type: MODAL_TYPE,
      });
    },
    handleReloadSampleAgent(agent) {
      this.setAgentData(agent, false);

      this.activeAlert({
        message: 'Agente atualizado com sucesso nas abas Memória de Campo e Resultado.',
        theme: 'success',
      });
    },
  },
  mounted() {
    Events.$on(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
  },
  beforeDestroy() {
    Events.$off(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
  },
};
